export class SignIn {
  constructor(instance) {
    this.instance = instance;
  }

  verificarCredenciais({ login, password, modo }) {
    return this.instance.post('/session', { login, password, modo });
  }

  refreshSession({ refreshToken }) {
    return this.instance.post('/session/refresh', { refreshToken });
  }

  logoutSession({ refreshToken }) {
    return this.instance.post('/session/logout', { refreshToken });
  }

  verificarToken() {
    return this.instance.get('/session');
  }

  forgotPassword({ email }) {
    return this.instance.post('/password/forgot', { email });
  }

  resetPassword({ senha, token }) {
    return this.instance.post('/password/reset', { senha, token });
  }

  updateLogin({ login, senha, email }) {
    return this.instance.put('/v1/perfil/migration-version', { senha, login, email });
  }

  showUser() {
    return this.instance.get('/v1/perfil/');
  }

  updateMyUser(dados) {
    return this.instance.put('/v1/perfil/', dados);
  }

  updatePassword({ senha_atual, senha_nova }) {
    return this.instance.put('/v1/perfil/password', { senha_atual, senha_nova });
  }

  uploadLogoRecibo(file) {
    const formData = new FormData();
    formData.append('logo_recibo', file);

    return this.instance.patch('/v1/perfil/logo-recibo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  removeLogoRecibo() {
    return this.instance.delete('/v1/perfil/logo-recibo');
  }

  sendWhatsappCode({ phone }) {
    return this.instance.post('/v1/perfil/whatsapp/send-code', { phone });
  }

  verifyWhatsappCode({ phone, code }) {
    return this.instance.post('/v1/perfil/whatsapp/verify', { phone, code });
  }

  listFaturas(filters) {
    return this.instance.get('/adm/licenses', {
      params: filters || null,
    });
  }

  lastFatura() {
    return this.instance.get('/adm/licenses/ultima-fatura');
  }
}

export default (...params) => new SignIn(...params);
